module.exports = {"520302001":"老城街道","520302002":"万里路街道","520302003":"中华路街道","520302004":"迎红街道","520302005":"延安路街道","520302006":"舟水桥街道","520302007":"中山路街道","520302008":"北京路街道","520302009":"长征街道","520302010":"礼仪街道","520302011":"南关街道","520302012":"忠庄街道","520302013":"新蒲街道","520302014":"新中街道","520302101":"巷口镇","520302104":"海龙镇","520302105":"深溪镇","520302106":"金鼎山镇","520302108":"新舟镇","520302109":"虾子镇","520302110":"三渡镇","520302111":"永乐镇","520302112":"喇叭镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/520302.json
// module id = 2595
// module chunks = 0